'use strict';
var toString = Object.prototype.toString;

module.exports = function (x) {
	return toString.call(x) === '[object Function]';
};



//////////////////
// WEBPACK FOOTER
// ./~/is-fn/index.js
// module id = 1203
// module chunks = 0